import {
  downloadCustomReport,
  dropCr,
  excuteSQL,
  getAllCustomReport,
  oneCr,
  saveCr,
  sqlShow
} from '../services/reportService';
import pathToRegexp from 'path-to-regexp';
import { PATHS } from '../utils/constants';

const keywords = [
  'DROP',
  'DELETE',
  'INSERT',
  'UPDATE',
  'ALL',
  'CREATE',
  'ALTER',
  'TABLE',
  'CALL',
  'SET',
  'GRANT',
  'EXECUTE',
  'REVOKE',
  'TRUNCATE',
  'SHOW',
  'USE',
  'FLUSH',
  'SHUTDOWN',
  'KILL',
  'SOURCE',
  'COMMIT',
  'ROLLBACK',
  'LOCK',
  'WAIT',
  'LIMIT'
];

const sqlInvaild = sql => {
  // 检查sql中的非法关键字
  const words = sql.split(' ');
  return words.some(w => keywords.some(k => k === w.toUpperCase()));
};

export default {
  namespace: 'customReport',
  state: {
    keywords,
    pageNo: 1,
    total: 0,
    crId: 0,
    crName: '',
    crSql: '',
    showInfo: false,
    errorInfo: false,
    infoMsg: '',
    sqlResult: [],
    reports: [],
    pageSize: 8,
    pageSizeShow: 20
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *initPage(_, { call, put }) {
      const { status, data } = yield call(getAllCustomReport);
      if (status === 0) {
        const payload = {
          crId: 0,
          crName: '',
          crSql: '',
          pageNo: 1,
          total: 0,
          sqlResult: [],
          reports: data
        };
        yield put({ type: 'setState', payload });
      }
    },
    *showPage(_, { call, put, select }) {
      const payload = {
        crId: 0,
        crName: '',
        crSql: '',
        pageNo: 1,
        total: 0,
        sqlResult: [],
        reports: []
      };
      const { pageNo: page, crId: id, pageSizeShow: size } = yield select(
        state => state.customReport
      );
      payload.crId = id;
      payload.pageNo = page;
      const {
        status,
        data: { name }
      } = yield call(oneCr, id);
      if (status === 0) {
        payload.crName = name;
        const {
          status,
          data: { list, total },
          msg
        } = yield call(sqlShow, page, id, size);
        if (status === 0) {
          payload.total = total;
          payload.sqlResult = list;
        }
      }
      yield put({ type: 'setState', payload });
    },
    *exportPage(_, { call, select }) {
      const { crId: id } = yield select(state => state.customReport);
      const { token } = yield select(state => state.login);
      const { locale } = yield select(state => state.i18n);
      yield call(downloadCustomReport, { id, token, locale });
    },
    *excuteSQL(_, { call, select, put }) {
      const { crSql, pageNo, pageSize: size } = yield select(
        state => state.customReport
      );
      const { messages } = yield select(state => state.i18n);
      if (!crSql || crSql === '') {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_sql_null']
        });
        return;
      } else if (sqlInvaild(crSql)) {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_sql_keyword_invalid']
        });
        return;
      } else if (crSql.indexOf(';') > -1) {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_sql_fenhao_forbidden']
        });
        return;
      }

      const { status, data, msg } = yield call(excuteSQL, crSql, pageNo, size);
      if (status === 0) {
        yield put({
          type: 'showTips',
          errorInfo: false,
          infoMsg: messages['report_custom_sql_querry_success']
        });
        const { list, total } = data;
        yield put({ type: 'setState', payload: { total, sqlResult: list } });
      } else {
        yield put({ type: 'showTips', errorInfo: true, infoMsg: msg });
      }
    },
    *showTips({ errorInfo, infoMsg }, { put }) {
      yield put({
        type: 'setState',
        payload: { showInfo: true, errorInfo, infoMsg }
      });
      setTimeout(() => {
        window.rc_dispatch({
          type: 'setState',
          payload: { showInfo: false, errorInfo: false, infoMsg: '' }
        });
      }, 5000);
    },
    *save(_, { call, select, put }) {
      const { token } = yield select(state => state.login);
      const { messages } = yield select(state => state.i18n);
      const { crId, crSql, crName } = yield select(state => state.customReport);
      if (!crName || crName === '') {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_name_placeholder']
        });
        return;
      } else if (!crSql || crSql === '') {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_sql_null']
        });
        return;
      } else if (sqlInvaild(crSql)) {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_sql_keyword_invalid']
        });
        return;
      } else if (crSql.indexOf(';') > -1) {
        yield put({
          type: 'showTips',
          errorInfo: true,
          infoMsg: messages['report_custom_sql_fenhao_forbidden']
        });
        return;
      }

      const { status, msg } = yield call(saveCr, crId, crName, crSql, token);
      if (status === 0) {
        yield put({
          type: 'showTips',
          errorInfo: false,
          infoMsg: messages['report_custom_save_success']
        });
        const { status, data } = yield call(getAllCustomReport);
        if (status === 0) {
          const payload = {
            crId: 0,
            crName: '',
            crSql: '',
            pageNo: 1,
            total: 0,
            sqlResult: [],
            reports: data
          };
          yield put({ type: 'setState', payload });
        }
        yield put({ type: 'menu/getMenu' });
      } else {
        yield put({ type: 'showTips', errorInfo: true, infoMsg: msg });
      }
    },
    *delete({ id }, { select, call, put }) {
      const { token } = yield select(state => state.login);
      const { messages } = yield select(state => state.i18n);
      const { status, msg } = yield call(dropCr, id, token);
      if (status === 0) {
        yield put({
          type: 'showTips',
          errorInfo: false,
          infoMsg: messages['report_custom_delete_success']
        });
        const { status, data } = yield call(getAllCustomReport);
        if (status === 0) {
          const payload = {
            crId: 0,
            crName: '',
            crSql: '',
            pageNo: 1,
            total: 0,
            sqlResult: [],
            reports: data
          };
          yield put({ type: 'setState', payload });
        }
        yield put({ type: 'menu/getMenu' });
      } else {
        yield put({ type: 'showTips', errorInfo: true, infoMsg: msg });
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(rooter => {
        const { pathname } = rooter;
        if (pathname === PATHS.customReport) {
          window.rc_dispatch = dispatch;
          dispatch({ type: 'initPage' });
        }
        const pathReg = pathToRegexp(PATHS.customReportShow);
        if (pathReg.test(pathname)) {
          const crId = pathname.split('/').pop();
          window.rc_dispatch = dispatch;
          dispatch({ type: 'setState', payload: { crId, pageNo: 1 } });
          dispatch({ type: 'showPage' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/customReport.js